import { useState } from 'react';
import { Box, Button } from '@mui/material';
import { css } from '@emotion/react';

import { GeopostPopup } from 'components/geopostPopup/GeopostPopup';
import { LazyDropdown, ILazyDropdownOption } from 'components/lazyDropdown/LazyDropdown';
import { ServerDropdown } from 'components/serverDropdown/ServerDropdown';
import { INameTokenViewModel } from 'models/interfaces/INameTokenViewModel';
import { useGetSurveyByName, useGetProductBySurvey } from '../api/useSurveyManagementController';
import { useAssociateSeismicAttribute } from '../api/useSeismicAttributesController';

const formStyle = css({
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    width: '100%',
});

interface IQueueProcessingAssociateAttributePopupProps {
    open: boolean;
    onChangeOpen: (open: boolean) => void;
    volumeToken: string;
}

export function QueueProcessingAssociateAttributePopup({ open, onChangeOpen, volumeToken }: IQueueProcessingAssociateAttributePopupProps) {
    const [selectedSurvey, setSelectedSurvey] = useState<ILazyDropdownOption<INameTokenViewModel> | null>(null);
    const [selectedProductToken, setSelectedProductToken] = useState<string | null>(null);

    const { fetchSurveys } = useGetSurveyByName();
    const { data: productOptions = [], isLoading: isLoadingProducts } = useGetProductBySurvey(selectedSurvey?.value.Token);
    const { mutate: associateAttribute, isLoading: isSaving } = useAssociateSeismicAttribute();

    const handleSurveyChange = (option: ILazyDropdownOption<INameTokenViewModel> | null) => {
        setSelectedSurvey(option);
        setSelectedProductToken(null);
    };

    const handleConfirm = () => {
        if (!selectedProductToken) {
            return;
        }

        associateAttribute(
            { volumeToken, seismicProductToken: selectedProductToken },
            { onSuccess: () => onChangeOpen(false) }
        );
    };

    return (
        <GeopostPopup
            open={open}
            onChangeOpen={onChangeOpen}
            title='Associar Atributos'
            width={480}
            height={310}
            resizable={false}
            draggable
            overlay
            padding='20px'
            footer={
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button variant='outlined' onClick={() => onChangeOpen(false)} sx={{ textTransform: 'none' }}>
                        Cancelar
                    </Button>
                    <Button
                        variant='contained'
                        onClick={handleConfirm}
                        disabled={!selectedSurvey || !selectedProductToken || isSaving}
                        sx={{ textTransform: 'none' }}
                    >
                        {isSaving ? 'Salvando...' : 'Confirmar'}
                    </Button>
                </Box>
            }
        >
            <div css={formStyle}>
                <LazyDropdown
                    value={selectedSurvey}
                    onChange={handleSurveyChange}
                    fetchOptions={fetchSurveys}
                    label='Survey'
                    placeholder='Digite para buscar...'
                />
                <ServerDropdown
                    value={selectedProductToken}
                    onChange={setSelectedProductToken}
                    options={productOptions}
                    loading={isLoadingProducts}
                    label='Product'
                    disabled={!selectedSurvey}
                />
            </div>
        </GeopostPopup>
    );
}
